import { useState } from 'react'
import { Button, HStack, Text, chakra } from '@chakra-ui/react'
import { choiceLabel, stepText, type ThreadItem } from '../../../../lib/conversation'
import type { ScriptLanguage } from '../../../../lib/walkPrefs'

/** [Spec §4.6] One finished step as a one-liner: question + answer + Change; a Say step with View. */
export function ThreadLine({ item, language, onChange }: { item: ThreadItem; language: ScriptLanguage; onChange?: () => void }) {
  const [open, setOpen] = useState(false)
  if (item.type === 'tag') return <Text fontSize="sm" color="fg.muted" px={1}>{`Tag added: ${item.label}`}</Text>
  const text = stepText(item.step, language)
  if (item.step.kind === 'say') {
    return (
      <HStack align="flex-start" gap={2} px={1}>
        <Text flex={1} fontSize="sm" color="fg.muted" whiteSpace="pre-wrap" lineClamp={open ? undefined : 1}>{text}</Text>
        <Button size="sm" variant="ghost" minH="44px" onClick={() => setOpen(o => !o)}>{open ? 'Hide' : 'View'}</Button>
      </HStack>
    )
  }
  return (
    <HStack align="center" gap={2} px={1}>
      <Text flex={1} fontSize="sm" lineClamp={2}>
        <chakra.span color="fg.muted">{text} </chakra.span>
        <chakra.span fontWeight="bold">{choiceLabel(item.step, item.choice, language)}</chakra.span>
      </Text>
      {onChange && <Button size="sm" variant="ghost" minH="44px" aria-label={`Change: ${text}`} onClick={onChange}>Change</Button>}
    </HStack>
  )
}
